import React from "react";
import { ExternalLinkDisclaimer } from "@gonoodle/gn-universe-ui";
import { isLocalURL } from "@gonoodle/gn-universe-utils";
import { useRouter } from "next/router";
import useCountDown from "react-countdown-hook";

import { useLogEvent } from "../contexts/Analytics";
import { ROUTE_PREFIX } from "../constants";

const ExternalLinkDisclaimerPage = () => {
  const countdownTime = 5000;
  const router = useRouter();
  const [timeLeft, { start }] = useCountDown(countdownTime, 1000);
  const [link, setLink] = React.useState();

  React.useEffect(() => {
    if (router.isReady) {
      if (!router.query.href) {
        router.replace(ROUTE_PREFIX.HOME);
      } else {
        setLink(router.query.href);
        start();
      }
    }
  }, [router, start]);

  const { isSuccess, isError } = useLogEvent({
    event: "Leaving GoNoodle Bumper Displayed",
    properties: {
      title: router.query.title,
      url: link,
      optionSelected: isLocalURL(link)
        ? "Back to Gonoodle"
        : "Went to External Link",
    },
    options: {
      enabled: !!(router.isReady && link && timeLeft === 0),
    },
  });

  React.useEffect(() => {
    if (isSuccess || isError) {
      window.location.replace(link);
    }
  }, [isSuccess, isError, link, router]);

  const handleClick = () => {
    setLink(ROUTE_PREFIX.HOME);
    start(0);
  };

  return (
    <ExternalLinkDisclaimer time={timeLeft / 1000} onClick={handleClick} />
  );
};

export default ExternalLinkDisclaimerPage;
